export enum EquipmentType {
    FurnaceCoils = "Furnace/Coils",
    AirHandlers = "Air Handlers",
    OutdoorUnits = "Outdoor Units",
    PackagedUnits = "Packaged Units",
    DuctlessProducts = "Ductless Products",
    IndoorAirQuality = "Indoor Air Quality",
    ComfortControls = "Comfort Controls",
    LightCommercial = "Light Commercial",
  }